<template>
  <div class="col-12 d-flex flex-column mb-3">
    <div style="flex: 1;margin-left: 45px;">
      <div class="row">
        <div class="col-12">
          <section-title :title="label" />
        </div>
      </div>
    </div>
    <div class="form-row">
      <div
        :class="{'col-md-9': !disabled, 'col-md-8': disabled}"
        class="mb-2"
        style="height: 38px;">
        <div class="d-flex">
          <div style="width: 45px;"/>
          <div
            class="form-row"
            style="flex: 1;">
            <div class="col-12">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ $t('apps.inventory.message.bin') }}</span>
                </div>
                <BaseDropdown
                  v-model="value.binId"
                  :options="binOptions"
                  :disabled="disabled" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    warehouses: Array,
    selectedWhId: String,
    disabled: Boolean,
    label: String,
  },

  computed: {
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    binOptions () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.selectedWhId) {
          const bins = cur.bin_locations.map((bin) => {
            return {
              text: bin.code,
              value: bin._id,
            }
          })
          if (bins.length) {
            acc.push(...bins)
          }
        }
        return acc
      }, [])
      return [this.defaultOption, ...items]
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseGTPutAwayLot.vue